import { AppStore } from "@/store/AppStore";
import { GatedFeature } from "@/store/feature-gates/types";

export interface MonetizationUsagePayload {
  note_create_quota_used: number;
  note_create_quota_limit: number | typeof Infinity;
  note_create_usage_ratio: number;
  chat_message_send_quota_used: number;
  chat_message_send_quota_limit: number | typeof Infinity;
  chat_message_send_chat_usage_ratio: number;
}

export async function buildMonetizationUsagePayload(
  store: AppStore
): Promise<MonetizationUsagePayload> {
  const [noteGate, chatGate] = await Promise.all([
    store.featureGates.checkGate(GatedFeature.NoteCreate),
    store.featureGates.checkGate(GatedFeature.ChatMessageSend),
  ]);

  const safeRatio = (used: number, limit: number | typeof Infinity) =>
    limit === Infinity || limit === 0 ? 0 : used / (limit as number);

  return {
    note_create_quota_used: noteGate.used,
    note_create_quota_limit: noteGate.limit,
    note_create_usage_ratio: safeRatio(noteGate.used, noteGate.limit),
    chat_message_send_quota_used: chatGate.used,
    chat_message_send_quota_limit: chatGate.limit,
    chat_message_send_chat_usage_ratio: safeRatio(chatGate.used, chatGate.limit),
  };
}
